export default __webpack_public_path__ + "static/banner-finance-winter-finances-88b632d70205a56bf6a7cffc9d434017.jpg";